module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_j_normal.e08bbeb0.png";